import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLock2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLock2"><Path fillRule="evenodd" clipRule="evenodd" d="M12 1.5C14.7614 1.5 17 3.73858 17 6.5V8.25684C18.8283 9.72298 20 11.9741 20 14.5C20 18.9183 16.4183 22.5 12 22.5C7.58172 22.5 4 18.9183 4 14.5C4 11.9741 5.17169 9.72298 7 8.25684V6.5C7 3.73858 9.23858 1.5 12 1.5ZM11 17H13V12.25H11V17ZM12 3.5C10.3431 3.5 9 4.84315 9 6.5V7.08301C9.92657 6.70786 10.9389 6.5 12 6.5C13.0611 6.5 14.0734 6.70786 15 7.08301V6.5C15 4.84315 13.6569 3.5 12 3.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLock2;
